import React from 'react';
import { Fade } from 'src/animations';
import { htmlTag } from 'src/types';
import { Text } from 'src/widget';
import classes from './SectionTitle.module.scss';

type Props = {
  title: string;
  subTitle?: string;
  hasMarginBottom?: boolean;
};

const UnmemoSectionTitle: React.FC<Props> = ({
  title,
  subTitle,
  hasMarginBottom = false
}) => (
  <div
    className={`${classes.wrapper} ${
      hasMarginBottom ? classes.hasMarginBottom : ''
    } ${subTitle ? classes.hasSubTitle : ''}`}
  >
    <Fade>
      <Text tag={htmlTag.h2}>{title}</Text>
    </Fade>
    {subTitle && (
      <Fade>
        <Text>{subTitle}</Text>
      </Fade>
    )}
  </div>
);

export const SectionTitle = React.memo(UnmemoSectionTitle);
